module.exports = __webpack_public_path__ + "img/Manageengine-IPFIX.38b4629.svg";